import React, { FC } from 'react'
import { VisitorType } from '../../__App/page-events-handler'
import { EmailPreferenceSection, PreferenceSection } from './PreferenceSection'
import { StyledMastheadPreference } from './PreferenceSection.styled'

interface MastheadPreferenceProps {
    preferences: EmailPreferenceSection[]
    logo: JSX.Element
    isLoading: boolean
    visitorType: VisitorType
}

export const MastheadPreference: FC<MastheadPreferenceProps> = ({
    preferences,
    logo,
    isLoading,
    visitorType,
}) => {
    return (
        <StyledMastheadPreference>
            {logo}
            {preferences.map((preferenceSection, index) => (
                <PreferenceSection
                    section={preferenceSection}
                    key={index}
                    isLoading={isLoading}
                    visitorType={visitorType}
                />
            ))}
        </StyledMastheadPreference>
    )
}
